import { Provider } from 'react-redux';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './presentation/routeCaching/queryClient';
import { store } from './presentation/store';
import { AppRoutes } from './presentation/routing/AppRoutes';

// Main App component
function App() {
  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <div className="App">
          <AppRoutes />
        </div>
      </QueryClientProvider>
    </Provider>
  );
}

export default App;